import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=a8243418&scoped=true&"
import script from "./BlogArticle.vue?vue&type=script&lang=js&"
export * from "./BlogArticle.vue?vue&type=script&lang=js&"
import style0 from "./BlogArticle.vue?vue&type=style&index=0&id=a8243418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8243418",
  null
  
)

export default component.exports